'use strict';
var populationSpans = Array.from(document.querySelectorAll('.population'));
var populationNumbers = populationSpans.map(function(el) {
    return Number(el.textContent.replaceAll(',', ''));
});
var total = populationNumbers.reduce(function(sum, current) {
    return sum + current;
}, 0);
var average = total / populationNumbers.length;
var totalFormatted = total.toLocaleString('en-US');
var averageFormatted = average.toLocaleString('en-US');
var totalContainer = document.querySelector('.total-population');
var averageContainer = document.querySelector('.average-population');
totalContainer.textContent = totalFormatted;
averageContainer.textContent = averageFormatted;

//# sourceMappingURL=js_get_data_DOM.26423b2b.js.map
